import React, { useState } from 'react'

import mapObject from '../../utils/mapObject'
import Constants from '../../constants'

import { ReactComponent as InfoBubbleIcon } from '../../assets/icons/ui/info-bubble.svg'
import poleNumberExample1 from '../../assets/images/pole-number-example-1.png'
import poleNumberExample2 from '../../assets/images/pole-number-example-2.png'

const PoleNumberInfo = ({ visible }) => {
  if (!visible) return null
  return (
    <div className="pole-number-legend">
      <p>The following are examples of where the pole number is located on a street light.</p>
      <img src={poleNumberExample1} alt="Pole Number Example 1" />
      <img src={poleNumberExample2} alt="Pole Number Example 2" />
    </div>
  )
}

const createOptions = ([key, value]) => (<option key={`${key}__${value}`} value={key}>{value}</option>)

const problemTypeOptions = mapObject(Constants.PROBLEM_TYPES, createOptions)
const lightTypeOptions = mapObject(Constants.LIGHT_TYPES, createOptions)

export const OutageInfoFieldset = ({ bindPoleNumber, bindProblemType, bindLightType, bindComments, asset }) => {
  const [poleNumberLegend, setPoleNumberLegend] = useState(false)

  const handlePoleNumberLegendClick = (event) => {
    event.preventDefault()
    setPoleNumberLegend(!poleNumberLegend)
  }

  return (
    <fieldset>
        
      <div className="input">
        <label htmlFor="pole-number" className="label">
          Pole Number
          <InfoBubbleIcon onClick={handlePoleNumberLegendClick} />
          <PoleNumberInfo visible={poleNumberLegend} />
        </label>
        {asset.status === "Adhoc" ?
          <input type="text" maxLength = "10" {...bindPoleNumber} /> :
          <input type="text"  maxLength = "10" readOnly = {true} {...bindPoleNumber} />}
      </div>

      <div className="input">
        <label htmlFor="problem-type" className="label">Problem Type</label>
        <select {...bindProblemType}>{problemTypeOptions}</select>
      </div>

      <div className="input">
        <label htmlFor="light-type" className="label">Light Type</label>
        <select {...bindLightType}>{lightTypeOptions}</select>
      </div>

      <div className="input">
        <label htmlFor="comments" className="label">Comments (Optional)</label>
        <textarea {...bindComments}></textarea>
      </div>
    </fieldset>
  )
}

export default OutageInfoFieldset
